// Shared header navigation. Independent of homepage product sections.
(function () {
  if (window.hwusNavigationInstalled) return;
  window.hwusNavigationInstalled = true;

  function closeMenu() {
    var button = document.querySelector('.hwus-mobile-menu');
    var menu = document.getElementById('main-nav');
    if (!button || !menu) return;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Open navigation');
    menu.classList.remove('is-expanded');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.hwus-mobile-menu');
    if (toggle) {
      var menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      menu.classList.toggle('is-expanded', open);
      return;
    }
    var link = event.target.closest('a[href]');
    if (!link) return;
    if (link.closest('#main-nav')) closeMenu();
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    var destination;
    try { destination = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_) { return; }
    if (!destination) return;
    event.preventDefault();
    destination.scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    // Keep Shopify's preview query/cookie context when following a local anchor.
    history.replaceState(null, '', location.pathname + location.search + url.hash);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var button = document.querySelector('.hwus-mobile-menu[aria-expanded="true"]');
    if (button) { closeMenu(); button.focus(); }
  });
  document.addEventListener('shopify:section:load', closeMenu);
})();
